"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAVIGATOR = -1;
exports.PREVIEW = 0;
exports.ADDONS = 1;
